import { Controller } from "stimulus"
import { get as getRequest } from '@rails/request.js'
import { get, snakeCase, values } from 'lodash'

const getData = async url => await getRequest(url).then(response => response.json)
const documentableInputId = value => `document_${snakeCase(value)}_id_input`

export default class extends Controller {
  static targets = ['documentableTypeWrapper', 'documentableType', 'documentableId']

  connect() {
    const target = this.documentableTypeTargets.find(x => x.checked)
    if (target) {
      this.documentableTypeChange(target.value)
      this.documentCategoryChanged({target: document.getElementById('document_document_category_id')}, true)
    }
  }

  documentableTypeChecked(evt) {
    this.documentableTypeChange(evt.target.value)
    this.documentableIdTarget.value=null
    jQuery('.documentable-id-input select').empty()
  }

  documentableTypeChange(documentableType) {
    const show = element => {
      element = document.getElementById(element)
      element.hidden = false
      element.classList.remove('hidden')
    }
    for (const element of document.getElementsByClassName('documentable-id-input')) {
      element.hidden = true
    }
    show(documentableInputId(documentableType))
  }

  updateDocumentableId(evt) {
    this.documentableIdTarget.value = evt.target.value
  }

  async documentCategoryChanged(evt, keep) {
    const documentCategoryId = evt.target.value
    const values = await getData(`/document_categories/${documentCategoryId}.json`)
    console.debug(values)
    const model_list = values.model_list
    for (const input of this.documentableTypeWrapperTarget.getElementsByTagName('input')) {
      const documentableInput = document.getElementById(documentableInputId(input.value))
      const li = document.querySelector(`li.choice:has(#${input.id})`)
      if(!keep) {
        input.checked = false
        documentableInput.hidden = true
      }
      if (model_list.includes(input.value)) {
        li.hidden = false
      } else {
        li.hidden = true
      }
    }
    this.documentableTypeWrapperTarget.classList.remove('hidden')
    // debugger
  }
}
